import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router";
import { AccountPassword } from "../organisms/AccountPassword";
import { AccountProfile } from "../organisms/AccountProfile";
import { TwoFactorAuthSettings } from "../organisms/TwoFactorAuthSettings";
import { useUserContext } from "../hooks/useUserContext";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "~/atoms/tabs";

export const AccountTab = {
  password: "password",
  profile: "profile",
  twoFA: "twoFA",
};

export const AccountSettings = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get("tab");

  const { user } = useUserContext();
  const { t } = useTranslation();
  const tabs = [
    {
      id: AccountTab.profile,
      label: t(($) => $.settings.profile.header),
      content: <AccountProfile />,
    },
    ...(!user.isSsoEnabled
      ? [
          {
            id: AccountTab.password,
            label: t(($) => $.settings.password.header),
            content: <AccountPassword />,
          },
          {
            id: AccountTab.twoFA,
            label: t(($) => $.settings["2fa"].header),
            content: <TwoFactorAuthSettings />,
          },
        ]
      : []),
  ];
  const activeTab =
    tabParam && tabs.some((tab) => tab.id === tabParam)
      ? tabParam
      : AccountTab.profile;

  const handleTabChange = (value: string) => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      next.set("tab", value);
      return next;
    });
  };

  return (
    <div className="container">
      <h3 className="py-7 text-4xl font-semibold">
        {t(($) => $.settings.header)}
      </h3>
      <Tabs
        value={activeTab}
        onValueChange={handleTabChange}
        className="max-w-2xl"
      >
        <TabsList>
          {tabs.map((tab) => (
            <TabsTrigger key={tab.id} value={tab.id}>
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>

        {tabs.map((tab) => (
          <TabsContent
            key={tab.id}
            value={tab.id}
            className="bg-card rounded-b-lg border-r border-b border-l px-4 py-6"
          >
            {tab.content}
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
};
